import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type { GetPublicIdInformationDetailResponse } from './type';

export async function getPublicIdInformationDetail(
  personId: string,
): Promise<GetPublicIdInformationDetailResponse> {
  const res = await apiClient.GET(
    '/v2/people-ledger/people/{personId}/public-id-information/detail',
    {
      params: {
        path: { personId },
      },
    },
  );
  return getDataOrThrowApiError(res);
}
